import { AxiosResponse } from "axios";
import { apisiseci } from "./api";
import { OrganResponse } from "../@types/organ";
import { DefaultFilter } from "../@types/filter";

type Props = DefaultFilter & {
  unidade_slug?: string;
};

export const getOrganList = (params?: Props): Promise<AxiosResponse<OrganResponse>> => {
  const token = localStorage.getItem("gov_access_token_sso");
  return apisiseci.get(
    "/cms/orgaos_perfil/",
    { headers: { Authorization: `Bearer ${token}`, }, params }
  );
}
